import { createContext, useContext } from "react";

import HttpClient from "../http-client/HttpClient";
import MortgageClient from "./MortgageClient";

const httpClient = new HttpClient();
const HttpClientContext = createContext<HttpClient>(httpClient);

const MortgageClientContext = createContext<MortgageClient>(new MortgageClient(httpClient));

export const useMortgageClient = () => {
    return useContext(MortgageClientContext);
};

export const useHttpClient = () => {
    return useContext(HttpClientContext);
};
